import * as React from 'react';

import * as styles from './ScrollContainer.css';

interface IScrollContainerProps {
  showScrollBottomButton?: boolean;
  onButtonVisible?(isVisible: boolean): void;
  onScroll(scrollTop: number): void;
  // Отступ сверху в пикселях, через который можно запросить следующую страницу
  whenRequestNextPage?: number;
  // Можно ли запросить следующую страницу
  canRequestNextPage?: boolean;
  children: React.ReactNode;
}

interface IScrollContainerState {
  buttonClickScroll: boolean;
}

// TODO: Переписать на функциональный компонент https://jira.cian.tech/browse/CD-189510
export class ScrollContainer extends React.Component<IScrollContainerProps, IScrollContainerState> {
  private containerElement: HTMLDivElement | null;
  private previousScrollHeight: number;
  private previousScrollTop: number;

  public state = {
    buttonClickScroll: false,
  };

  public componentDidMount() {
    if (this.containerElement) {
      const { scrollHeight } = this.containerElement;
      this.previousScrollHeight = scrollHeight;
      this.scrollToBottom();
    }
  }

  public componentDidUpdate(prevProps: IScrollContainerProps) {
    if (prevProps.children !== this.props.children && this.containerElement && !this.state.buttonClickScroll) {
      const { scrollHeight } = this.containerElement;
      const scrollTop = scrollHeight - this.previousScrollHeight + this.previousScrollTop;
      this.previousScrollHeight = scrollHeight;
      this.previousScrollTop = scrollTop;
      this.containerElement.scrollTop = scrollTop;

      this.setState({
        buttonClickScroll: false,
      });
    }
  }

  public render() {
    return (
      <div onScroll={this.onScroll} ref={r => (this.containerElement = r)} className={styles['container']}>
        {this.props.children}
      </div>
    );
  }

  public scrollToBottom = (buttonClickScroll?: boolean) => {
    if (this.containerElement) {
      const { scrollHeight } = this.containerElement;
      const { onButtonVisible, showScrollBottomButton } = this.props;

      if (buttonClickScroll) {
        this.setState({ buttonClickScroll });
      }

      this.containerElement.scrollTop = scrollHeight;
      this.previousScrollHeight = scrollHeight;

      if (showScrollBottomButton && onButtonVisible) {
        onButtonVisible(false);
      }
    }
  };

  public get isScrolledToBottom() {
    return this.containerElement
      ? this.containerElement.offsetHeight + this.containerElement.scrollTop >= this.containerElement.scrollHeight
      : false;
  }

  public get top() {
    return this.containerElement ? this.containerElement.getBoundingClientRect().top : 0;
  }

  public get height() {
    return this.containerElement ? this.containerElement.getBoundingClientRect().height : 0;
  }

  private onScroll = (e: React.UIEvent<HTMLDivElement>) => {
    const { onButtonVisible, onScroll, showScrollBottomButton } = this.props;
    const { scrollTop } = e.currentTarget;

    if (!this.containerElement) {
      return;
    }

    const { scrollHeight } = this.containerElement;
    const { height } = this.containerElement.getBoundingClientRect();

    this.previousScrollTop = scrollTop;

    if (showScrollBottomButton && onButtonVisible) {
      if (scrollTop + 100 <= scrollHeight - height) {
        onButtonVisible(true);
      } else {
        onButtonVisible(false);
      }
    }

    onScroll(scrollTop);
  };
}
